import React, {ComponentProps} from "react";
import Styles from './index.module.css'

interface Props extends ComponentProps<any> {
    description?: string
}

function ProfileTitle(props: Props) {
    return (
        <h3 className={Styles.container} style={{marginTop: 0}}>
            {props.children}
            <span style={{color: "gray", fontSize: 14, marginLeft: 10}}>{props.description}</span>
        </h3>
    )
}

export default ProfileTitle
